import useHttp from "components/hooks/useHttp";
import useToast from "components/hooks/useToast";
import useRouting from "hooks/useRouting";
import ReCaptcha from "modules/forms/components/recaptcha/ReCaptcha";
import useReCaptcha from "modules/forms/components/recaptcha/useReCaptcha";
import useForm from "modules/forms/hooks/useForm";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import BlockMapper from "modules/forms/hosted/blocks/BlockMapper";

export default function Authenticate() {
	const { form } = useForm();
	const { values, setIsSubmitting } = useFormFlow();
	const { push } = useRouting();
	const { errorToast, successToast } = useToast();
	const apiUrl = `/forms/${form.uuid}/private/authenticate-contact`;
	const http = useHttp();
	const recaptchaRef = useReCaptcha();
	const authPage = form.pages.find((p) => p.type === "auth");

	const authenticate = async () => {
		setIsSubmitting(true);
		const recaptchaToken = await recaptchaRef.current.executeAsync();

		http
			.withCaptcha(recaptchaToken)
			.post(apiUrl, values)
			.then(() => {
				successToast();
				push(`/forms/${form.uuid}/private/authenticate-success`);
			})
			.catch(errorToast)
			.finally(() => setIsSubmitting(false));
	};

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				authenticate();
			}}
		>
			{authPage.blocks.map((block) => (
				<BlockMapper key={block.uuid} block={block} />
			))}

			<ReCaptcha captchaRef={recaptchaRef} hideBadge={false} />
		</form>
	);
}
